import React from 'react';

/**
 * The standing accuracy note under every state summary a subscriber reads.
 *
 * One component so the sentence exists once: two copies of a disclaimer drift
 * apart. The text says "as of the verified date shown", so the date is shown
 * right here with it rather than relying on the page to print it somewhere
 * else. A state that has not been stamped yet says so instead of a date.
 */

export const STATE_SUMMARY_DISCLAIMER =
  'State rules are summarized from each state\'s statutes as of the verified date shown '
  + 'and are accurate to the best of our knowledge. States amend these laws, courts change '
  + 'how they apply, and county practice varies. Confirm current rules with the county and '
  + 'a local attorney before bidding. This is not legal advice.';

function StateSummaryDisclaimer({ verifiedAt }) {
  return (
    <div style={{
      marginTop: '12px',
      paddingTop: '12px',
      borderTop: '1px solid var(--color-border)',
      color: 'var(--color-text-muted)',
      fontSize: '0.8rem',
      lineHeight: 1.5
    }}>
      <div style={{ marginBottom: '4px' }}>
        {verifiedAt
          ? `Verified ${new Date(verifiedAt).toLocaleDateString()}`
          : 'Not yet verified'}
      </div>
      <p style={{ margin: 0 }}>{STATE_SUMMARY_DISCLAIMER}</p>
    </div>
  );
}

export default StateSummaryDisclaimer;
